import { getAttributeValue } from '@boc/framework/products/attributes';
import type {
  ProductCardFragment,
  ProductDetailsFragment,
} from '@boc/framework/saleor-graphql';

export const getPuzzlePieces = (
  product: ProductDetailsFragment | ProductCardFragment,
  format?: (value: string) => string
) => {
  return getAttributeValue(product.attributes, 'puzzle-pieces', format);
};

export const getPuzzleArtist = (
  product: ProductDetailsFragment | ProductCardFragment,
  format?: (value: string) => string
) => {
  return getAttributeValue(product.attributes, 'puzzle-artist', format);
};

export const getPuzzleSeries = (
  product: ProductDetailsFragment | ProductCardFragment,
  format?: (value: string) => string
) => {
  return getAttributeValue(product.attributes, 'puzzle-series', format);
};
